import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './MaintenanceSchedule.css';
import '../boxitem.css';
import '../topmenu.css';
import '../pageSearch.css';
import '../forms.css';

import { useTranslation } from 'react-i18next';

const EmailNotificationSettings = ({ apiBaseUrl, schedule, setSchedule }) => {
  const { t } = useTranslation(); // 👈 hook in translation

  const [technicians, setTechnicians] = useState([]);
  const [selectedTech, setSelectedTech] = useState('');

  useEffect(() => {
    axios
      .get(`${apiBaseUrl}/mnt/api/technicians`)
      .then((res) => {
        const dataArray = Array.isArray(res.data) ? res.data : [];
        setTechnicians(dataArray);
      })
      .catch((err) => console.error('Error fetching technicians:', err));
  }, [apiBaseUrl]);

  const handleUserSelect = (e) => {
    const techId = e.target.value;
    setSelectedTech(techId);
    const technician = technicians.find((tech) => tech.userid.toString() === techId);
    if (technician) {
      setSchedule({
        ...schedule,
        emailRecipient: technician.useremail || '',
      });
    } else {
      setSchedule({
        ...schedule,
        emailRecipient: '',
      });
    }
  };

  return (
    <div className="form-section">
      <h3>{t('emailSettings.title')}</h3>

      <div className="entry-item entry-item__small">
        <label htmlFor="techSelect">{t('emailSettings.selectTechnician')}</label>
        <select id="techSelect" value={selectedTech} onChange={handleUserSelect}>
          <option value="">{t('emailSettings.selectPlaceholder')}</option>
          {technicians.map((tech) => (
            <option key={tech.userid} value={tech.userid}>
              {tech.userfirstname || tech.userlastname
                ? `${tech.userfirstname} ${tech.userlastname}`.trim()
                : tech.username}
            </option>
          ))}
        </select>
      </div>

      <div className="entry-item entry-item__small">
        <label htmlFor="emailRecipient">{t('emailSettings.recipientEmail')}</label>
        <input
          id="emailRecipient"
          type="text"
          value={schedule.emailRecipient || ''}
          onChange={(e) =>
            setSchedule({ ...schedule, emailRecipient: e.target.value })
          }
          placeholder={t('emailSettings.emailPlaceholder')}
          />
          <small className="input-help-text">
            {t('emailSettings.multipleEmailsHelp')}
          </small>
      </div>

      <div className="entry-item entry-item__small">
        <label htmlFor="notificationDays">
          {t('emailSettings.daysBeforeDue')}
        </label>
        <input
          id="notificationDays"
          type="number"
          value={schedule.notificationDays || ''}
          onChange={(e) =>
            setSchedule({ ...schedule, notificationDays: e.target.value })
          }
          placeholder={t('emailSettings.daysPlaceholder')}
          min="0"
        />
      </div>
    </div>
  );
};

export default EmailNotificationSettings;
